// removed by extract-text-webpack-plugin
module.exports = {"tabWrapper":"_21Kw5d1iV_Y1Hg6Tj3nGCj","photoWrapper":"PMNwqb5bvlPtt4q3xAiuy","textWrapper":"_3X5zvijhTSZcwpc5v8dOxW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TabEstateBoard/TabEstateBoard.scss
// module id = 1781
// module chunks = 0